import { Alert, Card, Checkbox, Col, Form, message, Radio, Row, Select, Space } from "antd";
import { AntdButton, CheckboxField, DatePickerField, InputField, SelectInput, TextareaField } from "../../../blueplanitUtils/InputField";
import { useDispatch, useSelector } from "react-redux";
import { createJobPostingAsync, getJobRequisitionsAsync, getSingleJobRequisitionAsync, updateJobRequisitionAsync, updatePublishJobRequisitionAsync } from "../../../Slices/hiringSlice";
import { useEffect, useRef, useState } from "react";
import { getOptionsByPath } from "../../../utilsdata";
import { ADD_EDIT_EMPLOYEE, BASIC_INFO, EMPLOYEE_DEPARTMENT, EMPLOYMENT_TYPE, WORK_TYPE } from "../../../Dropdownmanager";
import { useNavigate, useParams } from "react-router-dom";
import { submitRefreshPage } from "../../../Slices/orderSlice";
import RichTextEditor from "../../../blueplanitUtils/RichTextEditor";

const JobPosting = () => {
    const { id } = useParams();
    const descriptionRef = useRef();
    const responsibilitiesRef = useRef();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const NestedDatabucket = useSelector((state) => state.dataBucket.NestedDatabucket);
    const jobRequisition = useSelector((state) => state.hiring.singleJob);
    const details = useSelector((state) => state.employee.AllEmployees);



    const [formData, setFormData] = useState({
        requisitionId: "",
        designation: "",
        dept: "",
        skillsRequired: [],
        location: "",
        employmentType: "",
        workMode: "",
        salaryRange: "",
        experienceRequired: "",
        shift: "",
        jobDescription: "",
        jobResponsibilities: "",
        expiryDate: "",
        publishedSources: [],
        hasQuestions: "No",   // ✅ NEW
        questions: [],
        hasInterviewQuestions: "No",
        interviewQuestions: [],
        hasExam: "No",
        exam: {
            enabled: false,
            examTitle: "",
            examLink: "",
            durationInMinutes: 45,
            instructions: "",
            passingScore: "",
            questions: []
        },
        applyUrl: ""

    });

    useEffect(() => {
        dispatch(getJobRequisitionsAsync());
    }, [dispatch]);

    useEffect(() => {
        if (id) {
            dispatch(getSingleJobRequisitionAsync(id))
        }
    }, [dispatch, id]);


    useEffect(() => {
        if (jobRequisition) {
            setFormData({
                requisitionId: jobRequisition.requisitionId,
                designation: jobRequisition.designation || "",
                dept: jobRequisition.dept || "",
                assignedTo: jobRequisition.assignedTo || "",
                numberOfOpenings: jobRequisition.numberOfOpenings || "",
                employmentType: jobRequisition.employmentType || "",
                experienceRequired: jobRequisition.experienceRequired || "",
                workMode: jobRequisition.workMode || "",
                skillsRequired: (jobRequisition.skillsRequired || []).join(", "),  // convert array → comma text
                salaryRange: jobRequisition.salaryRange || "",
                shift: jobRequisition.shift || "",
                location: jobRequisition.location || "",
                reasonForHiring: jobRequisition.reasonForHiring || "",
                jobDescription: jobRequisition.jobDescription || "",
                jobResponsibilities: jobRequisition.jobResponsibilities || "",
                notes: jobRequisition.notes || "",
                publishedSources: jobRequisition?.[0]?.publishedSources,
                applyUrl: jobRequisition?.applyUrl,
                hasQuestions: jobRequisition?.questions?.length > 0 ? "Yes" : "No",
                questions: (jobRequisition?.questions || []).map((q) => ({
                    id: q.id,
                    type: q.type,
                    label: q.label,
                    options: q.options || [],
                    required: q.required
                })),
                hasInterviewQuestions: jobRequisition?.interviewQuestions?.length > 0 ? "Yes" : "No",
                interviewQuestions: (jobRequisition.interviewQuestions || []).map((q) => ({
                    questionId: q.questionId,
                    question: q.question,
                    category: q.category,
                    required: q.required
                })),
                hasExam: jobRequisition?.exam?.enabled ? "Yes" : "No",
                exam: {
                    examTitle: jobRequisition?.exam?.examTitle || "",
                    durationInMinutes: jobRequisition?.exam?.durationInMinutes || "",
                    passingScore: jobRequisition?.exam?.passingScore || "",
                    instructions: jobRequisition?.exam?.instructions || "",
                    examLink: jobRequisition?.exam?.examLink || "",
                    questions: jobRequisition?.exam?.questions || []
                }

            })
        }
    }, [jobRequisition])

    const assignedToOptions = details.map((emp) => ({
        label: emp.firstname + " " + emp.lastname,
        value: emp.id,
    }));

    const handleChange = (field, value) => {
        setFormData((prev) => ({
            ...prev,
            [field]: value
        }));
    };

    const addQuestion = () => {
        setFormData(prev => ({
            ...prev,
            questions: [
                ...prev.questions,
                {
                    id: `q_${Date.now()}`,
                    label: "",
                    type: "input",
                    options: [],
                    required: true
                }
            ]
        }));
    };



    const updateQuestion = (index, field, value) => {
        setFormData((prev) => {
            const questions = [...prev.questions];

            questions[index] = {
                ...questions[index],
                [field]: value
            };

            if (
                field === "type" &&
                !["radio", "checkbox", "select"].includes(value)
            ) {
                questions[index].options = [];
            }

            return {
                ...prev,
                questions
            };
        });
    };


    const addOption = (qIndex) => {
        setFormData((prev) => {
            const questions = [...prev.questions];
            questions[qIndex].options = [...questions[qIndex].options, ""];
            return { ...prev, questions };
        });
    };

    const updateOption = (qIndex, optIndex, value) => {
        setFormData((prev) => {
            const questions = [...prev.questions];
            const options = [...questions[qIndex].options];
            options[optIndex] = value;
            questions[qIndex].options = options;
            return { ...prev, questions };
        });
    };


    const removeOption = (qIndex, optIndex) => {
        setFormData((prev) => {
            const questions = [...prev.questions];
            questions[qIndex].options = questions[qIndex].options.filter(
                (_, i) => i !== optIndex
            );
            return { ...prev, questions };
        });
    };


    const removeQuestion = (index) => {
        setFormData((prev) => ({
            ...prev,
            questions: prev.questions.filter((_, i) => i !== index)
        }));
    };

    const addInterviewQuestion = () => {
        setFormData(prev => ({
            ...prev,
            interviewQuestions: [
                ...prev.interviewQuestions,
                {
                    question: "",
                    category: "Technical",
                    required: true
                }
            ]
        }));
    };

    const updateInterviewQuestion = (index, field, value) => {
        const updated = [...formData.interviewQuestions];
        updated[index][field] = value;
        setFormData({ ...formData, interviewQuestions: updated });
    };

    const removeInterviewQuestion = (index) => {
        const updated = [...formData.interviewQuestions];
        updated.splice(index, 1);
        setFormData({ ...formData, interviewQuestions: updated });
    };

    const handleSubmit = async () => {
        const skillsArray = formData.skillsRequired
            ? formData.skillsRequired.split(",").map(s => s.trim())
            : [];
        try {
            const payload = {
                designation: formData.designation,
                dept: formData.dept,
                assignedTo: formData.assignedTo,
                numberOfOpenings: Number(formData.numberOfOpenings),
                employmentType: formData.employmentType,
                experienceRequired: formData.experienceRequired,
                workMode: formData.workMode,
                skillsRequired: skillsArray,
                salaryRange: formData.salaryRange,
                shift: formData.shift,
                location: formData.location,
                jobDescription: formData.jobDescription,
                jobResponsibilities: formData.jobResponsibilities,
                questions: formData.hasQuestions === "Yes"
                    ? formData.questions.map((q) => ({
                        id: q.id,
                        type: q.type,
                        label: q.label,
                        options: q.options || [],
                        required: q.required
                    }))
                    : [],
                interviewQuestions: formData.hasInterviewQuestions === "Yes" ?
                    formData.interviewQuestions.map((q) => ({
                        questionId: q.questionId,
                        question: q.question,
                        category: q.category,
                        required: q.required

                    }))
                    : []
            }
            const response = await dispatch(
                updatePublishJobRequisitionAsync({ id, data: payload })
            ).unwrap();

            message.success({
                content: response.message || "Job Requisition Updated Successfully",
                duration: 2,
                className: "custom-toast-center"
            });
        }
        catch (error) {
            message.error("failed to create job posting")
        }
    }

    const cancelHandelar = () => {
        dispatch(submitRefreshPage(false))
        navigate("/JobPosting");
    };


    return (
        <div style={{ width: "100%", marginBottom: "5px" }}>
            <Form layout='vertical'>
                <Row justify="start" gutter={16} style={{ marginBottom: "7px" }}>
                    <Col span={24} style={{ marginTop: 16, textAlign: "left" }}>
                        <Space>
                            <AntdButton label="Submit" color='primary' variant='solid' htmlType="button" onClick={handleSubmit} />

                            <AntdButton label="Close" color='danger' variant='solid' onClick={cancelHandelar} />

                        </Space>
                    </Col>
                </Row>
                <Card
                    title="Update Job Posting"
                    style={{ marginBottom: "12px" }}
                >
                    <Row gutter={[16, 16]}>

                        <Col span={4}>
                            <InputField
                                label="Job Title"
                                name="designation"
                                placeholder="Enter job title"
                                value={formData.designation}
                                onChange={(e) => handleChange("designation", e.target.value)}
                            />
                        </Col>

                        <Col span={4}>
                            <InputField
                                label="Location"
                                name="location"
                                placeholder="Enter location"
                                value={formData.location}
                                onChange={(e) => handleChange("location", e.target.value)}
                            />
                        </Col>
                        <Col span={4}>
                            <SelectInput
                                label="Department"
                                name="dept"
                                value={formData.dept}
                                onChange={(value) => handleChange("dept", value)}
                                placeholder="Select Department"
                                style={{ width: '100%' }}
                                options={getOptionsByPath(NestedDatabucket, [ADD_EDIT_EMPLOYEE, EMPLOYEE_DEPARTMENT])}
                            />
                        </Col>
                        <Col span={4}>
                            <SelectInput
                                label="Assigned To"
                                name="assignedTo"
                                value={formData.assignedTo}
                                onChange={(value) => handleChange("assignedTo", value)}
                                style={{ width: "100%" }}
                                options={assignedToOptions}
                                placeholder="Select AssignedTo"

                            />
                        </Col>
                        <Col span={4}>
                            <SelectInput
                                label="Employment Type"
                                name="employmentType"
                                placeholder="Select type"
                                value={formData.employmentType}
                                style={{ width: "100%" }}
                                options={getOptionsByPath(NestedDatabucket, [BASIC_INFO, EMPLOYMENT_TYPE])}
                                onChange={(value) => handleChange("employmentType", value)}
                            />
                        </Col>

                        <Col span={4}>
                            <SelectInput
                                label="Work Mode"
                                name="workMode"
                                placeholder="Select Work Mode"
                                value={formData.workMode}
                                style={{ width: "100%" }}
                                options={getOptionsByPath(NestedDatabucket, [BASIC_INFO, WORK_TYPE])}
                                onChange={(value) => handleChange("workMode", value)}
                            />
                        </Col>
                        <Col span={6}>
                            <InputField
                                label="Salary Range"
                                name="salaryRange"
                                placeholder="Enter range"
                                value={formData.salaryRange}
                                onChange={(e) => handleChange("salaryRange", e.target.value)}
                            />
                        </Col>

                        <Col span={6}>
                            <InputField
                                label="Experience Required"
                                name="experienceRequired"
                                placeholder="e.g, 2+ years"
                                value={formData.experienceRequired}
                                onChange={(e) =>
                                    handleChange("experienceRequired", e.target.value)
                                }
                            />
                        </Col>

                        <Col span={6}>
                            <InputField
                                label="Skills Required"
                                name="skills"
                                type="tags"
                                value={formData.skillsRequired}
                                onChange={(e) => handleChange("skillsRequired", e.target.value)}
                                placeholder="Add required skills"
                            />

                        </Col>
                        <Col span={4}>
                            <SelectInput
                                label="Shift"
                                name="shift"
                                style={{ width: '100%' }}
                                value={formData.shift}
                                onChange={(value) => handleChange("shift", value)}
                                placeholder="Select Shift Type"
                                options={[
                                    { label: "General", value: "General" },
                                    { label: "Morning", value: "Morning" },
                                    { label: "Evening", value: "Evening" },
                                    { label: "Night", value: "Night" },
                                    { label: "Rotational", value: "Rotational" }
                                ]}
                            />
                        </Col>

                        <Col span={24}>
                            <RichTextEditor
                                label="Job Description"
                                ref={descriptionRef}
                                value={formData.jobDescription}
                                onChange={(value) => handleChange("jobDescription", value)}
                                placeholder="Enter job description"
                            />
                        </Col>

                        <Col span={24}>

                            <RichTextEditor
                                label="Job Responsibilities"
                                ref={responsibilitiesRef}
                                value={formData.jobResponsibilities}
                                onChange={(value) => handleChange("jobResponsibilities", value)}
                                placeholder="Enter responsibilities"
                            />
                        </Col>

                        <Col span={24}>
                            {jobRequisition?.applyUrl && (
                                <TextareaField
                                    label="Apply URL"
                                    value={formData.applyUrl}
                                />
                            )}
                        </Col>
                        <Col span={6}>
                            <Form.Item label="Questions">
                                <Radio.Group
                                    value={formData.hasQuestions}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        handleChange("hasQuestions", value);
                                        if (value === "No") {
                                            handleChange("questions", []);
                                        }
                                    }}
                                >
                                    <Radio value="Yes">Yes</Radio>
                                    <Radio value="No">No</Radio>
                                </Radio.Group>
                            </Form.Item>
                        </Col>

                        {formData.hasQuestions === "Yes" && (
                            <Col span={24}>
                                <Card
                                    size="small"
                                    extra={
                                        <AntdButton
                                            label="Add Question"
                                            color="primary"
                                            variant="outlined"
                                            onClick={addQuestion}
                                        />
                                    }
                                >
                                    {formData.questions.length === 0 && (
                                        <p style={{ color: "#999" }}>No questions added yet.</p>
                                    )}

                                    {formData.questions.map((q, index) => (
                                        <Card key={q.id} size="small" style={{ marginBottom: 12 }}>
                                            <Row gutter={8}>
                                                <Col span={14}>
                                                    <InputField
                                                        placeholder={`Question ${index + 1}`}
                                                        value={q.label}
                                                        onChange={(e) => updateQuestion(index, "label", e.target.value)}
                                                    />
                                                </Col>

                                                <Col span={5}>
                                                    <Select
                                                        value={q.type}
                                                        style={{ width: "100%" }}
                                                        onChange={(value) => updateQuestion(index, "type", value)}
                                                        options={[
                                                            { label: "Input", value: "input" },
                                                            { label: "Textarea", value: "textarea" },
                                                            { label: "Radio", value: "radio" },
                                                            { label: "Checkbox", value: "checkbox" },
                                                            { label: "Dropdown", value: "select" }
                                                        ]}
                                                    />
                                                </Col>

                                                <Col span={3}>
                                                    <Checkbox
                                                        checked={q.required}
                                                        onChange={(e) =>
                                                            updateQuestion(index, "required", e.target.checked)
                                                        }
                                                    >
                                                        Required
                                                    </Checkbox>
                                                </Col>

                                                <Col span={2}>
                                                    <AntdButton
                                                        label="✕"
                                                        color="danger"
                                                        variant="outlined"
                                                        onClick={() => removeQuestion(index)}
                                                    />
                                                </Col>
                                            </Row>

                                            {/* OPTIONS */}
                                            {["radio", "checkbox", "select"].includes(q.type) && (
                                                <div style={{ marginTop: 10 }}>
                                                    <b>Options</b>
                                                    {q.options.map((opt, optIndex) => (
                                                        <Row key={optIndex} gutter={8} style={{ marginTop: 6 }}>
                                                            <Col span={20}>
                                                                <InputField
                                                                    placeholder={`Option ${optIndex + 1}`}
                                                                    value={opt}
                                                                    onChange={(e) =>
                                                                        updateOption(index, optIndex, e.target.value)
                                                                    }
                                                                />
                                                            </Col>
                                                            <Col span={4}>
                                                                <AntdButton
                                                                    label="✕"
                                                                    color="danger"
                                                                    variant="outlined"
                                                                    onClick={() => removeOption(index, optIndex)}
                                                                />
                                                            </Col>
                                                        </Row>
                                                    ))}

                                                    <AntdButton
                                                        label="Add Option"
                                                        variant="outlined"
                                                        onClick={() => addOption(index)}
                                                        style={{ marginTop: 8 }}
                                                    />
                                                </div>
                                            )}
                                        </Card>
                                    ))}
                                </Card>
                            </Col>
                        )}
                        <Col span={24}>
                            <Form.Item label="Interview Questions">
                                <Radio.Group
                                    value={formData.hasInterviewQuestions}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        handleChange("hasInterviewQuestions", value);
                                        if (value === "No") {
                                            handleChange("interviewQuestions", []);
                                        }
                                    }}
                                >
                                    <Radio value="Yes">Yes</Radio>
                                    <Radio value="No">No</Radio>
                                </Radio.Group>
                            </Form.Item>
                        </Col>

                        {formData.hasInterviewQuestions === "Yes" && (
                            <Col span={24}>
                                <SelectInput
                                    label="Select Department"
                                    value={formData.dept}
                                    onChange={(value) => handleChange("dept", value)}
                                    placeholder="Select Department"
                                    options={getOptionsByPath(NestedDatabucket, [ADD_EDIT_EMPLOYEE, EMPLOYEE_DEPARTMENT])}
                                />
                            </Col>
                        )}

                        {formData.hasInterviewQuestions === "Yes" && formData.dept && (
                            <Col span={24}>
                                <Card
                                    size="small"
                                    extra={
                                        <AntdButton
                                            label="Add Interview Question"
                                            color="primary"
                                            variant="outlined"
                                            onClick={addInterviewQuestion}
                                        />
                                    }
                                >
                                    {formData.interviewQuestions.length === 0 && (
                                        <p style={{ color: "#999" }}>No interview questions added yet.</p>
                                    )}

                                    {formData.interviewQuestions.map((q, index) => (
                                        <Card
                                            key={index}
                                            size="small"
                                            style={{ marginBottom: 12 }}
                                        >
                                            <Row gutter={8}>
                                                <Col span={14}>
                                                    <InputField
                                                        placeholder={`Interview Question ${index + 1}`}
                                                        value={q.question}
                                                        onChange={(e) =>
                                                            updateInterviewQuestion(index, "question", e.target.value)
                                                        }
                                                    />
                                                </Col>

                                                <Col span={6}>
                                                    <SelectInput
                                                        value={q.category}
                                                        style={{ width: "100%" }}
                                                        onChange={(value) =>
                                                            updateInterviewQuestion(index, "category", value)
                                                        }
                                                        options={[
                                                            { label: "Technical", value: "Technical" },
                                                            { label: "HR", value: "HR" },
                                                            { label: "Behavioral", value: "Behavioral" },
                                                            { label: "Managerial", value: "Managerial" }
                                                        ]}
                                                    />
                                                </Col>

                                                <Col span={3}>
                                                    <CheckboxField
                                                        label="Required"
                                                        checked={q.required}
                                                        onChange={(e) =>
                                                            updateInterviewQuestion(index, "required", e.target.checked)
                                                        }
                                                    />
                                                </Col>

                                                <Col span={1}>
                                                    <AntdButton
                                                        label="✕"
                                                        color="danger"
                                                        variant="outlined"
                                                        onClick={() => removeInterviewQuestion(index)}
                                                    />
                                                </Col>
                                            </Row>
                                        </Card>
                                    ))}
                                </Card>
                            </Col>
                        )}
                    </Row>
                </Card>
            </Form>
        </div>

    )
};

export default JobPosting;